class EditToggle {
	click() {
		let elm = document.querySelectorAll(".delete-link");
		if (elm) {
			for (let i = 0; elm.length > i; i++) {
				elm[i].classList.toggle('show');
			}
		}
	}
}